import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    PianAtt,
    PianAttApiResponse,
    PianAttDTOApiResponse,
    mapPianAttToJson,
    mapJsonToPianAtt,
    mapJsonToPianAttDTOApiResponse,
    ClientiApiResponse, mapJsonToClientiApiResponse, PianAttDTO
} from "./types";
import {columnFiltersParamWithDateRange, sortingParam} from "../../common/Services";
import * as Yup from "yup";
import React from "react";
import {mapJsonToProgettiApiResponse, ProgettiApiResponse} from "../gestversore/types";



const moment = require('moment')

export function useGetPianAttDTO(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
    options?: { enabled?: boolean }
 ) {
    return useQuery<PianAttDTOApiResponse>({
        queryKey: [
            'fetchPianAttDTO',
            columnFilters, // refetch when columnFilters changes
            globalFilter,  // refetch when globalFilter changes
            pagination.pageIndex, // refetch when pagination.pageIndex changes
            pagination.pageSize, // refetch when pagination.pageSize changes
            sorting, // refetch when sorting changes
        ],
        queryFn: async () => {
            // Get isAdmin and coddip from localStorage at the start


              // const keycoddip = localStorage.getItem("keycoddip") || "";
              // const keyrole = localStorage.getItem("keyrole") || "";
              // const isAdmin =
              //     keyrole.includes('TimeReportAdmin') ||
              //     keyrole.includes('TimeReportPianAtt');
              //
              //
              // let coddip = 'NN';
              //
              // if (isAdmin) {
              //           coddip = '';
              //      } else {
              //           coddip = keycoddip ? keycoddip : 'NN' ;
              // }



            const myLimit=pagination.pageSize
            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;

            // ATTENZIONE IL FILTRO E DENTRO LA PAGINA PIANATT MENTRE GANTTATT MANDA LE COLONNE DA FILTRARE
            let myURL = `?limit=${myLimit}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                'VBT30'
            )}&ordering=${sortingParam(sorting, 'VBT30')}`;

            // if (coddip !== '') {
            //             myURL += `&VBT30_REF=${coddip}`;
            //     }

            const response = await AxiosInstance.get(`pianattdto/${myURL}`);

            return mapJsonToPianAttDTOApiResponse(response.data);
        },
        enabled: options?.enabled ?? true,
        refetchOnWindowFocus: false,
    });
}


export function useGetPianAttById(id: string) {
  return useQuery<PianAtt>({
    queryKey: ['fetchPianAtt', id],
    queryFn: async () => {

      const response = await AxiosInstance.get('pianatt/'+id+'/');

      // Log the response data itself
      // console.log('Raw response data:', response.data);

      const transformedData = mapJsonToPianAtt(response.data.data.PianAtt);

      // Log the transformed data
      // console.log('Transformed data:', transformedData);

      return transformedData;
    },
    refetchOnWindowFocus: false,
  });
}

export const getPianAttById = async (id: string): Promise<PianAtt> => {
  const response = await AxiosInstance.get(`pianatt/${id}/`);
  const transformedData = mapJsonToPianAtt(response.data.data.PianAtt);
  return transformedData;
};






export function useCreatePianAtt() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (pianatt: PianAtt) => {
      if (pianatt.datainiziopian) {
        pianatt.datainiziopian = moment(pianatt.datainiziopian).format('YYYY-MM-DD');
      }

      if (pianatt.datainizioeff) {
        pianatt.datainizioeff = moment(pianatt.datainizioeff).format('YYYY-MM-DD');
      }
      if (pianatt.datafinepian) {
        pianatt.datafinepian = moment(pianatt.datafinepian).format('YYYY-MM-DD');
      }

      if (pianatt.datainizioeff) {
        pianatt.datainizioeff = moment(pianatt.datainizioeff).format('YYYY-MM-DD');
      }

      if (pianatt.datafineeff) {
        pianatt.datafineeff = moment(pianatt.datafineeff).format('YYYY-MM-DD');
      }

      pianatt.ditta=2;

       const response = await AxiosInstance.post('pianatt/0/', mapPianAttToJson(pianatt));
       return response.data;

      // return AxiosInstance.post('pianatt/0/',mapPianAttToJson(pianatt));
    },

     onSuccess: () => {

       queryClient.invalidateQueries({ queryKey: ['fetchPianAttDTO'] });

   },
     });
}

export function useUpdatePianAtt() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (pianatt: PianAtt) => {
      // 🔥 CLONE – MAI mutare l'input
      const payload: PianAtt = {
        ...pianatt,
        datainiziopian: pianatt.datainiziopian
          ? moment(pianatt.datainiziopian).format("YYYY-MM-DD")
          : undefined,
        datafinepian: pianatt.datafinepian
          ? moment(pianatt.datafinepian).format("YYYY-MM-DD")
          : undefined,
        datainizioeff: pianatt.datainizioeff
          ? moment(pianatt.datainizioeff).format("YYYY-MM-DD")
          : undefined,
        datafineeff: pianatt.datafineeff
          ? moment(pianatt.datafineeff).format("YYYY-MM-DD")
          : undefined,
      };

      const response = await AxiosInstance.patch(
        `pianatt/${pianatt.id}/`,
        mapPianAttToJson(payload)
      );

      return response.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["fetchPianAttDTO"],
      });
    },
  });
}



export function useDeletePianAtt() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const response = await AxiosInstance.delete('pianatt/' + id + '/');
      return response.data;
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["fetchPianAttDTO"],
      });
    },
  });
}

export function useGetClienti(ditta: number) {
  return useQuery<ClientiApiResponse>({
    queryKey: ['fetchClienti'],
    queryFn: async () => {

      //console.log('call useGetClienti with:',codditta)
      const response = await AxiosInstance.get('clienti/?limit=10000&offset=0&VBT02_DITTA='+ditta);

      return mapJsonToClientiApiResponse(response.data)

      //const json = (response.data) as ClientiApiResponse;
      //console.log(response.data)
      // return json;
    },
    refetchOnWindowFocus: false,
  });
}


export function useGetProgettiPianAtt(filterProgs: string) {
  return useQuery<ProgettiApiResponse>({
    queryKey: ['fetchProgettiByRef', filterProgs],
    queryFn: async () => {
      const ditta = localStorage.getItem('keyidazienda') || 0;
      let coddip = localStorage.getItem('coddip') || '';
      const role = localStorage.getItem('keyrole') || '';

      if (role.includes('TimeReportAdmin')) {
        coddip = 'NN';
      }

      // console.log('filterProgs',filterProgs);

      // gestione progetti per pianatt se admin in add solo APERTI se ref all solo APERTI se edit tutti ???


const url =
  filterProgs === 'addAdminProgs'
    ? `progetti/?limit=10000&offset=0&VBT01_DITTA__exact=${ditta}&VBT01_STATOPROG__exact=APERTO`
    : filterProgs === 'editAdminProgs'
      ? `progetti/?limit=10000&offset=0&VBT01_DITTA__exact=${ditta}`
      // : `progetti/?limit=10000&offset=0&VBT01_REF__exact=${coddip}&VBT01_DITTA__exact=${ditta}&VBT01_STATOPPROG__exact=APERTO`;
        : `progetti/?limit=10000&offset=0&VBT01_DITTA__exact=${ditta}&VBT01_STATOPROG__exact=APERTO&REF_OR_NULL=${coddip}`;

      const response = await AxiosInstance.get(url);
      return mapJsonToProgettiApiResponse(response.data);
    },
    refetchOnWindowFocus: false,
  });
}







// export async function jasperPianAttDTOBlob( ditta: String, codprog: String, formato: String) {
export async function jasperPianAttDTOBlob(  formato: String) {
  try {
    const username = 'jasperadmin';
    const password = 'Tibco2024@';
    const base64encodedData = Buffer.from(`${username}:${password}`).toString('base64');

    // const fromDateString = fromDate ? format(fromDate, 'yyyy-MM-dd') : '';
    // const toDateString = toDate ? format(toDate, 'yyyy-MM-dd') : '';

         let pag = '';
             if (formato === 'xlsx') {
                pag = 'ignorePagination=true&'
            }

    // check codcli = 0 for admin

      // const mycodprog = codprog === '0' ? '' : codprog;

   // const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/pianattetto${formato}.${formato}?${pag}codprog=${mycodprog}&ditta=${ditta}`, {
    const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/pianattetto${formato}.${formato}?${pag}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/'+formato,
        'Authorization': `Basic ${base64encodedData}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch the report');
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error; // Rethrow the error to handle it in the calling code if needed
  }
};

export const validationSchema = Yup.object().shape({
                      // fromDate: Yup.date().required('Selezione Data Inizio'),
                      // toDate: Yup.date().test('is-after-or-equal', 'La data di fine deve essere successiva alla data di inizio', function (value) {
                      //                    const { fromDate } = this.parent; // Access fromDate from parent object
                      //                    if (!fromDate || !value) {
                      //                    return true; // Skip validation if fromDate or toDate is not set
                      //                 }
                      //                 return fromDate <= value; // Validate if toDate is after or equal to fromDate
                      //               }),
                      emailTo: Yup.string().email('Email non è valida'),
                    });

export const validationSchemaPianAtt = Yup.object().shape({
              // id: Yup.number(),
              // ditta: Yup.number(),
              // idcli:  Yup.string().nullable().optional(),
              codprog: Yup.string().required(),
              codnodo: Yup.string().required(),
              // ref: Yup.string(),
               datainiziopian: Yup.date()
                        .required("Data inizio pianificazione obbligatoria")
                        .max(
                          Yup.ref("datafinepian"),
                          "La data inizio non può essere maggiore della data fine"
                        ),

               datafinepian: Yup.date()
                        .required("Data fine pianificazione obbligatoria")
                        .min(
                          Yup.ref("datainiziopian"),
                          "La data fine non può essere minore della data inizio"
                        ),
               datainizioeff: Yup.date()
                        .nullable()
                        .max(
                          Yup.ref("datafineeff"),
                          "La data inizio effettiva non può essere maggiore della data fine effettiva"
                        ),
               datafineeff: Yup.date()
                            .nullable()
                            .min(
                              Yup.ref("datainizioeff"),
                              "La data fine effettiva non può essere minore della data inizio effettiva"
                            ),
              note: Yup.string().nullable(),
              coddip: Yup.string().required(),
              // priorita: Yup.string(),
              percomp: Yup.number(),
              orepian: Yup.number(),
              minpian: Yup.number(),
              ref: Yup.string(),
              orainiz: Yup.number().typeError('Numero').min(8).max(20).integer().required(),
              mininiz: Yup.number().typeError('Numero').min(0).max(59).integer().required(),
              orafine: Yup.number().typeError('Numero').min(8).max(20).integer().required(),
              minfine: Yup.number().typeError('Numero').min(0).max(59).integer().required(),
        });
